/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshSavingsHome} from '../api'

export const useMutationRefreshSavingsHome = createReactQueryMutationHook('refreshSavingsHome', refreshSavingsHome)
